import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { GlowCard } from "@/components/GlowCard";
import { COMPANY } from "@/content/galaxy";

export default function Impressum() {
  return (
    <LegalLayout badge="RECHTLICHES" title="IMPRESSUM" testId="impressum-page">
      <p className="text-white/55">
        Offenlegung & Anbieterkennzeichnung gemäß § 5 ECG, § 14 UGB und § 25 MedienG.
      </p>

      <GlowCard className="p-6">
        <LegalSection heading="Medieninhaber & Diensteanbieter">
          <p className="text-white">{COMPANY.legalName}</p>
          <p>
            {COMPANY.street}
            <br />
            {COMPANY.zip} {COMPANY.city}
            <br />
            {COMPANY.country}
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="Kontakt">
          <p>
            E-Mail:{" "}
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="impressum-email-link"
              className="text-gl-blue2 transition-colors hover:text-white"
            >
              {COMPANY.email}
            </a>
          </p>
          <p>
            Telefon:{" "}
            <a
              href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
              data-testid="impressum-phone-link"
              className="text-gl-blue2 transition-colors hover:text-white"
            >
              {COMPANY.phone}
            </a>
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="Unternehmensdaten">
          <p>Rechtsform: Gesellschaft mit beschränkter Haftung (GmbH)</p>
          <p>Firmenbuchnummer: {COMPANY.registerNumber}</p>
          <p>Firmenbuchgericht: {COMPANY.registerCourt}</p>
          <p>Eingetragen seit: {COMPANY.foundedDate}</p>
          <p>Unternehmensgegenstand: {COMPANY.businessPurpose}</p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="Vertretungsbefugtes Organ">
          <p>Geschäftsführer: {COMPANY.managingDirector}</p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="Online-Streitbeilegung">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
            bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="impressum-odr-link"
              className="text-gl-blue2 transition-colors hover:text-white"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            . Unsere E-Mail-Adresse findest du oben. Wir sind nicht verpflichtet und nicht bereit,
            an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="Haftung für Inhalte & Links">
          <p>
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            Unsere Website enthält unter Umständen Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der
            jeweilige Anbieter oder Betreiber verantwortlich.
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="Urheberrecht">
          <p>
            Die auf dieser Website veröffentlichten Inhalte und Werke unterliegen dem
            österreichischen Urheberrecht. Jede Verwertung außerhalb der Grenzen des Urheberrechts
            bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Urhebers bzw. Erstellers.
          </p>
        </LegalSection>
      </GlowCard>

      <p className="text-xs text-white/40">Stand: {COMPANY.lastUpdated}</p>
    </LegalLayout>
  );
}
